module.exports = __webpack_public_path__ + "img/111.7f1e5174.jpg";